module.exports = __webpack_public_path__ + "31f2f6e7184d510a594eb00d8341a8fc.pdf";